import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface UserProfileCardData {
  photoURL?: string;
  name: string;
  title?: string;
  email: string;
  phone?: string;
}

@Component({
  selector: 'lib-user-profile-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './common-ui-components-user-profile-card.component.html',
  styleUrl: './common-ui-components-user-profile-card.component.scss',
})
export class UserProfileCardComponent {
  @Input() user!: UserProfileCardData;
  @Input() hideContactInfo = false;
}
